const mutations = {
    setSelectedListingForReport(state, listing) {

        state.listingForReport = listing

    },
}
export default mutations
